import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { userExternalSignInCallBack } from '../appRedux/actions';
import CircularProgress from '../components/CircularProgress';
import queryString from 'query-string';
// import { Container } from './styles';

function CallBackExternalLogin() {
  const location = useLocation();
  const values = queryString.parse(location.search)
  const history = useHistory();
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(userExternalSignInCallBack(values));
  }, [values]);

  const {
    loader,
    token,
    alertMessage,
    showMessage,
  } = useSelector(({ auth }) => {
    return auth;
  });


  useEffect(() => {
    if (token != null) {
      history.push("/samplePage");
    }
  });
  
  return (
    <div>
      {loader ? (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      ) : null}
    </div>
  );
}

export default CallBackExternalLogin;